import React from 'react';
import ReactDOM from 'react-dom/client';
import { initI18n } from './i18n';
import './styles/global.css';
import App from './App';

// Résout la langue (query/stockage/navigateur) avant le 1er render pour éviter
// un flash de la mauvaise langue.
initI18n().finally(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});

// Service worker minimal (offline app-shell + cache des assets). Indisponible en
// dev (vite ne sert pas /sw.js depuis public en mode module HMR) — no-op silencieux.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // updateViaCache:'none' → le script sw.js est toujours revalidé depuis le
    // réseau (jamais servi depuis le cache HTTP), pour détecter chaque nouveau
    // build sans délai.
    navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' }).catch(() => {});
  });
}
